import { isSafari } from '../../utils.js';
import { sortBy, uniq, cloneDeep } from 'lodash';
import * as PIXI from 'pixi.js-legacy';
import MultiStyleText from '@/vendor/pixi-multistyle-text.js';

const MAX_SAFARI_TEXT_SIZE = 36;

//require('pixi.js');
//const MultiStyleText = require('pixi-multistyle-text');
function findComponent(gameobjects, id) {
  return gameobjects.componentIdCache[id];
  /*
  const x = gameobjects.components.filter( (c) => {
    return c.id === id;
  } );
  if (x) {
    return x[0];
  }
  return null;
  */
}

const TEXT_UPSCALE = 4;
function getNextPowerOfTwo(x) {
  return Math.pow(2, Math.floor(Math.log(x)/Math.log(2)));
}

const DEFAULT_TEXT_OPTIONS = {
  stroke: 'black',
  strokeThickness: 0,
  dropShadow: false,
  dropShadowAlpha: 1,
  dropShadowAngle: Math.PI / 6,
  dropShadowBlur: 20,
  dropShadowColor: 'black',
  dropShadowDistance: 0
}

function getMipmappedTexture(hasWebGl, texture, canvas) {
  if (!hasWebGl) {
    return texture;
  }
  return texture;
  //return PIXI.Texture.fromCanvas(canvas);
  var canvas = document.createElement("canvas"),
      context = canvas.getContext("2d"),
      bt = texture.baseTexture;

  bt.update();
  bt.mipmap = true;
  bt.scaleMode = PIXI.SCALE_MODES.LINEAR;

  canvas.width = getNextPowerOfTwo(bt.width);
  canvas.height = getNextPowerOfTwo(bt.height);
  //canvas.width = bt.width;
  //canvas.height = bt.height;
  context.drawImage(bt.source, 0, 0, canvas.width, canvas.height);

  var newBaseTexture = new PIXI.BaseTexture(canvas, PIXI.SCALE_MODES.LINEAR);
  newBaseTexture.mipmap = true;
  var newTexture = new PIXI.Texture(newBaseTexture, PIXI.SCALE_MODES.LINEAR);
  newTexture.frame = new PIXI.Rectangle(0, 0, canvas.width, canvas.height);
  newTexture.mipmap = true;

  if (canvas.parent) {
    canvas.parent.remove(canvas);
  }

  return newTexture;
}


function findSlotsNoCache(gameobjects, component, name) {
  const components = [];
  const length = gameobjects.links.length;
  for (var i = 0; i < length; i++) {
    const link = gameobjects.links[i];

    if (!name || link.name === name) {
      if (link.source === component.id) {
        components.push(findComponent(gameobjects, link.target));
      }
    }
  }
  return components;

}
function prePopulateIdCache(tiledata) {
  const cache = {};
  tiledata.components.forEach( (component) => {
    cache[component.id] = component;
  });
  ((tiledata.remix||{}).components||[]).forEach( (remixed) => {
    cache[remixed.id] = remixed;
  });
  return cache;
}

function prePopulateCache(tiledata) {
  const cache = {};
  const componentsById = {};
  const linksByTarget = {};
  const linksBySource = {};
  tiledata.components.forEach( (component) => {
    componentsById[component.id] = component;
  });
  ((tiledata.remix||{}).components||[]).forEach( (remixed) => {
    componentsById[remixed.id] = remixed;
  });
  tiledata.links.forEach( (link) => {
    if (!linksByTarget[link.target]) {
      linksByTarget[link.target] = [];
    }
    if (!linksBySource[link.source]) {
      linksBySource[link.source] = [];
    }
    linksByTarget[link.target].push(link);
    linksBySource[link.source].push(link);
  });
  function linkComponent(component) {
    const linksFor = linksBySource[component.id] || [];
    cache[component.id + '-__ALL_LINKS'] = linksFor;
    const allkey = component.id + '-undefined';
    if (!cache[allkey]) {
      cache[allkey] = [];
    }

    const targetComponents = linksFor.map( (l) => {
      const c = componentsById[l.target];
      const key = component.id + '-' + l.name;
      if (!cache[key]) {
        cache[key] = [];
      }
      cache[key].push({component:c,link:l});
      return {component:c,link:l};
    });
    cache[allkey] = cache[allkey].concat(targetComponents);

  }
  tiledata.components.forEach(linkComponent);
  ((tiledata.remix||{}).components||[]).forEach(linkComponent);
  return cache;
}


function Coords(gameobjects, screenWidth, screenHeight, _gameWidth, _gameHeight, game, transform) {
  this.screenWidth = screenWidth;
  this.screenHeight = screenHeight;
  this._gameWidth = _gameWidth;
  this._gameHeight = _gameHeight;
  this.game = game;
  this.transform = transform;

  this.cols = parseInt(game.cols) || 20;
  this.rows = parseInt(game.rows) || 12;
  if (this.cols === 0) {
      this.cols = 20;
  }
  if (this.rows === 0) {
      this.rows = 12;
  }
  this.screenCols = this.cols;
  this.screenRows = this.rows;
  this.extents = {
    x1:transform.x - game.cols/2,
    x2:transform.x + game.cols/2,
    y1:transform.y - game.rows/2,
    y2:transform.y + game.rows/2
  }

  //const hheight = Math.max(screenHeight - 180, screenWidth* 9/16, 200);
  //const wwidth = Math.min((hheight+90) * 16/9, screenWidth);
  //const height = wwidth * 9/16;
  //const gameWidth = screenWidth;
  //const gameHeight = height;

  this.hheight = Math.min(this.screenHeight, this.screenWidth* this.rows/this.cols);
  this.wwidth = Math.min((this.hheight+90) * this.cols/this.rows, this.screenWidth);
  this.gameWidth = this.wwidth;
  this.gameHeight = this.hheight;

  this.grid = this.gameWidth / this.screenCols;
  this.gridy = this.gameHeight / this.screenRows;

  this.cameraX = this.transform.x;
  this.cameraY = this.transform.y;
  this.offsetX = (this.screenWidth - this.gameWidth) / 2 - (this.transform.x -this.screenCols/2)* this.grid;
  this.offsetY = (this.screenHeight - this.gameHeight) / 2 - (this.transform.y -this.screenRows/2)* this.gridy;


}
Coords.prototype.convertWidth = function (scalex, width) {
  const desiredWidth = scalex * this.grid;
  return desiredWidth / width;
}
Coords.prototype.convertHeight = function (scaley, height) {
  const desiredHeight = scaley * this.gridy;
  return desiredHeight/ height;
}
Coords.prototype.dimToScreenX = function (x) {
  return Math.abs(x * this.grid);
}
Coords.prototype.dimToScreenY = function (y) {
  return Math.abs(y * this.gridy);
}
Coords.prototype.toScreenX = function (x) {
  return this.offsetX + x * this.grid;
}
Coords.prototype.toScreenY = function (y) {
  return this.offsetY + y * this.gridy;
}
Coords.prototype.toWorldX = function (x) {
  const o = (x-this.offsetX) / this.grid;
  return o;
}
Coords.prototype.toWorldY = function (y) {
    const o = (y-this.offsetY) / this.gridy;
    return o;
}
Coords.prototype.dimToWorldX = function (x) {
  return x / this.grid;
}
Coords.prototype.dimToWorldY = function (y) {
  return y/this.gridy;
}
Coords.prototype.isOutside = function (transform) {
  const x = transform.x;
  const y = transform.y;
  const x1 = -20
  const x2 = 20
  const y1 = -20
  const y2 = 20
  return (x < x1 || x > x2 || y < y1 || y > y2);
}
Coords.prototype.isInScreen = function (transform) {
  const screenX = this.toScreenX(transform.x);
  const screenY = this.toScreenY(transform.y);
  const halfWidth = this.dimToScreenX(transform.scalex)/2;
  const halfHeight = this.dimToScreenY(transform.scaley)/2;
  return screenX >= -halfWidth && screenY >= -halfHeight
    && screenX <= this.screenWidth + halfWidth && screenY <= this.screenHeight + halfHeight;
    
}
Coords.prototype.isInCamera = function (transform) {
    const x = transform.x;
    const y = transform.y;
    const left = this.cameraX - (this.cols+2)/2 - transform.scalex;
    const right = this.cameraX + (this.cols+2)/2 + transform.scalex;
    const top = this.cameraY - (this.rows+2)/2 - transform.scaley;
    const bottom = this.cameraY + (this.rows+2)/2 + transform.scaley;
    const inCamera = x >= left && y >= top && x <= right && y <= bottom;
    return inCamera || this.isInScreen(transform);
}
function cleanMeasureOptions(options) {
  delete options.stroke;
  delete options.strokeThickness;
  delete options.dropShadow;
  delete options.dropShadowAlpha;
  delete options.dropShadowAngle;
  delete options.dropShadowBlur;
  delete options.dropShadowColor;
  delete options.dropShadowDistance;
  //options.fontSize /= 2
  return options;
}

function measureStyledText(themes, text, defaultOpts) {
  const to = mergeTextOptions(defaultOpts);
  const defaults = cleanMeasureOptions(to);
  const measure = new PIXI.TextMetrics.measureText(text, new PIXI.TextStyle(defaults));
  //measure.width *= 2
  //measure.height *= 2
  return measure;
}

function makeBoundedBackground(data, scale, graphics, renderTools) {
  graphics.clear();
  graphics.beginFill(makeColor(data.bgcolor));
  graphics.scale.x = 1/scale.x;
  graphics.scale.y = 1/scale.y;
  //this.parentContainer.addChild(graphics);
  const {x,y} = scale;
  const left = -x/2;
  const right = x/2;
  const top = -y/2;
  const bottom = y/2;
  //const {right,left,top,bottom} = this.data.boundingBox;
  const points = [ [left,top], [right,top], [right,bottom], [left, bottom] ].map( ([x,y]) => {
    return new PIXI.Point(
      renderTools.worldToScreen_x(x),
      renderTools.worldToScreen_y(y)
    )
  })
  graphics.drawPolygon(points);
  graphics.endFill();
}

function makeTextBackground(text, textOptions, convertWidthAndHeightToWorld, pixiApp) {

  const measure = measureStyledText({}, text, textOptions);
  let measureWorld = convertWidthAndHeightToWorld(measure.width, measure.height);

  const scalefactor = 1;
  measureWorld = {
    width:measureWorld.width / scalefactor,
    height:measureWorld.height / scalefactor
  }

  const shapeData = {
    color:textOptions.bgcolor,
    stroke:textOptions.bgcolor,
    lineWidth:0,
    scalex:measureWorld.width + 1,
    scaley:measureWorld.height + 1
  }

  return shapeData;
  
}


function makeFittedText(themes, text, in_defaultOpts, boundingBox, convertWidthAndHeightToWorld, renderTools, prerendered) {
  const t1 = new Date().getTime();
  text = (text||'').trim()
  if (prerendered) {
    //text += "[" + in_defaultOpts.size.toFixed(1) + "]"
    const t = makeStyledText(themes, text, in_defaultOpts);
    return {
      text:t,textOptions:in_defaultOpts
    }
  }
  const defaultOpts = Object.assign({}, in_defaultOpts, {
    size: in_defaultOpts.size * 1,
    wordWrapWidth: renderTools.worldToScreen_x(boundingBox.right - boundingBox.left)
  });
  const relativeDropShadowDistance = (defaultOpts.dropShadowDistance || 0) / defaultOpts.size * 2;
  let measure = measureStyledText({}, text, defaultOpts);
  let measureWorld = convertWidthAndHeightToWorld(measure.width, measure.height);
    //text += defaultOpts.size.toFixed(1) + "/"
    //text += measure.height.toFixed(2) + "/"
    //text += measureWorld.height.toFixed(2)

  //
  //
  measureWorld = {
    width:measureWorld.width,
    height:measureWorld.height
  }

  const width = Math.min(boundingBox.right - boundingBox.left,10000000) - 0.2;
  const height = boundingBox.bottom - boundingBox.top;

  let sizedWidth = false;
    defaultOpts.size *= Math.min(width / measureWorld.width, height / measureWorld.height);
    sizedWidth = true;
    //text += "*";
  //text += measureWorld.width.toFixed(1) + "/" + width.toFixed(1)

  if (sizedWidth) {
    measure = measureStyledText({}, text, defaultOpts);
    measureWorld = convertWidthAndHeightToWorld(measure.width, measure.height);
  }
  const MAX_TEXT_SIZE = 48*4/TEXT_UPSCALE;
  const prevSize  = defaultOpts.size;
  if (measureWorld.height > height) {
    const prevSize  = defaultOpts.size;
    defaultOpts.size *= height / measureWorld.height;
    defaultOpts.size = Math.max(8,defaultOpts.size);
    defaultOpts.dropShadowDistance = defaultOpts.size * relativeDropShadowDistance;
    defaultOpts.wordWrapWidth *= defaultOpts.size/prevSize;
    //text += "[";
  }
    //text += measure.width.toFixed(1) + "/" + measure.height.toFixed(1);
  if (measureWorld.height < height && height > 0.4) {
    const availableHeightFactor = (height / measureWorld.height - 0.2)
    const availableWidthFactor = 1
    const availableSpace = availableHeightFactor * availableWidthFactor;
    //let f;

    let tries = [
      measure.lines.length/(measure.lines.length+1) * availableSpace,
      measure.lines.length/(measure.lines.length+1.5) * availableSpace,
      measure.lines.length/(measure.lines.length+2) * availableSpace,
      2.9,
      2.8,
      2.7,
      2.3,
      2,
      1.8,
      1.5,
      1.3,
    ]
    tries = sortBy(tries, parseFloat);
    tries = uniq(tries);
    //tries.uniq();
    //tries.reverse();

    // TODO: short circuit this
    let f = 1;
    for (let i = 0; i < tries.length; i++) {
      const t = tries[i];
      if (defaultOpts.size * t > MAX_TEXT_SIZE) {
        continue;
      }

      const testOpts = cloneDeep(defaultOpts);
      testOpts.size *= t;
      const testMeasure = measureStyledText({}, text, testOpts);
      const testMeasureWorld = convertWidthAndHeightToWorld(testMeasure.width, testMeasure.height);

      if (testMeasureWorld.height >= height - 0.1 || testMeasureWorld.width >= width+0.2) {
        break;
      }
      f = t;
    }

    defaultOpts.size *= f;
    defaultOpts.size = Math.max(defaultOpts.size, prevSize);

    //text += "-" + measure.lines.length + ":" + f.toFixed(1)
    //text += f.toFixed(1) + ":" + availableSpace.toFixed(1)
    //text += "-" + measureWorld.height.toFixed(1) + "/" + height.toFixed(1)

    //text += width.toFixed(1) + "/" + height.toFixed(1);
    //text += " [" + defaultOpts.size.toFixed(1) + "]"
  }

  defaultOpts.size = Math.min(MAX_TEXT_SIZE, defaultOpts.size);
  defaultOpts.dropShadowDistance = defaultOpts.size * relativeDropShadowDistance;

  //text += "[" + defaultOpts.size.toFixed(1) + "]"

  const t = makeStyledText(themes, text, defaultOpts);
  t.hitArea = new PIXI.Rectangle(-0.5, -0.5, 1, 1);

  const t2 = new Date().getTime();
  return {
    text:t,textOptions:defaultOpts,bla:text
  }

}

function mergeTextOptions(defaultOpts) {
const o = {...DEFAULT_TEXT_OPTIONS, ...{
    align:defaultOpts.align || 'center',
    fontFamily: defaultOpts.font || 'Arial',
    //fontSize: defaultOpts.size,
    fontSize: defaultOpts.v == 2 ? defaultOpts.size * TEXT_UPSCALE : defaultOpts.size,
    //fontStyle: 'italic',
    //fontWeight: 'bold',
    fill: [defaultOpts.color||'#ffffff'],
    wordWrap: true,
    wordWrapWidth: defaultOpts.wordWrapWidth
  }}


  const otherKeys = [
    'stroke',
    'strokeThickness',
    'dropShadow',
    'dropShadowColor',
    'dropShadowBlur',
    'dropShadowAngle',
    'dropShadowDistance'
  ]


  otherKeys.forEach( (k) => {
    if (typeof(defaultOpts[k]) !== 'undefined') {
      o[k] = defaultOpts[k]
    }
  });

  //o.stroke = '#000000'
  //o.strokeThickness = 4;
  //o.dropShadow = true;
  //o.dropShadowDistance = 10;
  //o.dropShadowBlur = 20;
  return o;


}
function makeStyledText(themes, text, defaultOpts) {
  /*
  const gameText = new PIXI.Text(text, {
    fontFamily: defaultOpts.font || 'Arial',
    align:defaultOpts.align || 'center',
    fill: [defaultOpts.color||'#ffffff'],
    fontSize: defaultOpts.size,
  });
  return gameText;
  */
      //fill: [ent.gameText.component.color||'#ffffff'],
  const defaults = mergeTextOptions(defaultOpts);
  const style = {
    default:Object.assign({
        wordWrap:true,
        wordWrapWidth:defaultOpts.v == 2 ? (600 / (4/TEXT_UPSCALE)) : 300
      },defaults),
    p:{},
    strong:{fontWeight:'bold'},
    bold:{fontWeight:'bold'},
    italic:{fontStyle:'italic'},
    small:{fontSize:'14px'},
    medium:{fontSize:'32px'},
    large:{fontSize:'64px'},
  };
  for (let j = 0; j < (themes||[]).length; j++) {
    const theme = themes[j];
    style[theme.name] = theme;
    style[theme.name.toLowerCase()] = theme;
  }

  let safariWorkAround = 0;
  if (isSafari() && style.default.fontSize > MAX_SAFARI_TEXT_SIZE) {
    safariWorkAround = style.default.fontSize / MAX_SAFARI_TEXT_SIZE;
    style.default.fontSize = MAX_SAFARI_TEXT_SIZE
    style.default.wordWrapWidth /= safariWorkAround;
  }

  const t = new PIXI.Text(text, style.default);
  // this fixes text not rendering correctly / black rectangles for
  // text on some devices.
  t.resolution = 1;

  if (safariWorkAround) {
    t.scale.set(safariWorkAround, safariWorkAround);
  }

  return t;
  //return new MultiStyleText(text, style);

}
function makeColor(x) {
  if (!x) {
    return '0xffffff';
  }
  if (x.indexOf('#') === 0) {
    return x.replace('#', '0x')
  } else {
    return x;
  }
}

const defaultRenderTools = {
  worldToScreen_x: (x) => x*(1920/16),
  worldToScreen_y: (y) => y*(1080/9)
}
function makeShape(themes, graphics, component, renderTools = defaultRenderTools) {
  graphics.clear();
  let chosenTheme;
  if (component.theme && component.theme !== '') {
    for (let j = 0; j < (themes||[]).length; j++) {
      const theme = themes[j];
      if (theme.name === component.theme) {
        chosenTheme = theme;
      }
    }
  }
  if (component.shapetype === 'circle') {
    const fillColor = makeColor(component.color);
    const strokeColor = makeColor(component.stroke);
    const lineWidth = renderTools.worldToScreen_x(component.lineWidth)/10;

    if (chosenTheme) {
      graphics.lineStyle(component.lineWidth, makeColor(chosenTheme.stroke));
      graphics.beginFill(makeColor(chosenTheme.fill));
    } else {
      if (component.stroke !== '') {
        graphics.lineStyle(lineWidth, strokeColor);
      }
      graphics.beginFill(fillColor);
    }
    const width = renderTools.worldToScreen_x(1);
    const height = renderTools.worldToScreen_y(1);
    graphics.drawEllipse(width/2 * 1, height/2 * 1, width/2 * 1, height/2 * 1);
    //graphics.scale.x = 1/1;
    //graphics.scale.y = 1/1;
    graphics.endFill()

  } else if (component.shapetype === 'custom') {
    const polygon = _.flatten(component.points.map( (p) => {
      return [p.x,p.y];
    }));
    graphics.beginFill(0xffff00);
    graphics.drawPolygon(polygon);
    graphics.endFill();
  } else {

    if (chosenTheme) {
      graphics.lineStyle(component.lineWidth, makeColor(chosenTheme.stroke));
      graphics.beginFill(makeColor(chosenTheme.fill));
    } else {
      const fillColor = makeColor(component.color);
      const strokeColor = makeColor(component.stroke);
      const lineWidth = renderTools.worldToScreen_x(component.lineWidth)/10;

      if (component.stroke !== '') {
        graphics.lineStyle(lineWidth, strokeColor);
      }
      graphics.beginFill(fillColor);
    }


    const width = renderTools.worldToScreen_x(component.scalex);
    const height = renderTools.worldToScreen_y(component.scaley);
    graphics.drawRect(-width/2, -height/2, width,height);
    graphics.endFill();
  }

}

function moveTilingSprite(component, sprite, worldPos, width, height) {
  const offsetx = !isNaN(component.offsetx) ? (component.offsetx * width): 0;
  const offsety = !isNaN(component.offsety) ? (component.offsety * height): 0;
  if (component.lockToCamera) {
    let factorx = !isNaN(component.parallaxx) ? component.parallaxx : 1;
    let factory = !isNaN(component.parallaxy) ? component.parallaxy : 1;
    sprite.tilePosition.set( 
      (worldPos.x*(1920/16) + offsetx) * factorx, 
      (worldPos.y*(1920/16) + offsety) * factory
    )
  } else {
    sprite.tilePosition.set(offsetx, offsety);
  }
}
function makeTilingSprite(component, texture, transform, anchorx, anchory, sprite=undefined) {
  /*
  let texture;
  if (component.atlas) {
    texture = resources[component.atlas].textures[component.texture]
  } else {
    texture = resources[component.texture].texture;
  }
  */
  function convertScale(x) {
    return x * (1920/16);
  }
  const width = convertScale(transform.scale.x * transform.localScale.x);
  const height = convertScale(transform.scale.y * transform.localScale.y);

  let basesizex = component.basesizex;
  let basesizey = component.basesizey;

  if (component.basesizex === -1) {
    basesizex = width / texture.width;
    basesizey = height / texture.height;
  }

  if (!sprite) {
    sprite = new PIXI.TilingSprite(texture, width, height)
  }

  sprite.tileScale.x = component.sizex * basesizex;
  sprite.tileScale.y = component.sizey * basesizey;

  sprite.x = -width * anchorx;
  sprite.y = -height * anchory;

  return {sprite,width,height};

}

export {
  Coords,
  prePopulateCache,
  getMipmappedTexture,
  prePopulateIdCache,
  makeStyledText,
  makeShape,
  measureStyledText,
  makeTextBackground,
  makeTilingSprite,
  moveTilingSprite,
  makeFittedText,
  makeBoundedBackground,
  TEXT_UPSCALE
}


